export enum SalesRequestsPermissions {
  Sales = 'sales'
}
